import '../index.css'
import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'
import * as React from 'react'
import validation from 'react-validation-mixin'
import strategy from 'react-validatorjs-strategy'
import type { LinkProps } from 'types/content-editor'
import type { ValidationProps } from 'types/validation'
import { fixLink, LINK_VALIDATOR, validateLink } from '@disco/utils/links'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import LinkPropsView from './view'

class LinkSettings extends React.Component<
  {
    value: LinkProps
    onSubmit: (form: Record<string, any>) => unknown
    onCancel: () => unknown
  } & ValidationProps,
  {
    value: Record<string, any>
  }
> {
  state = {
    value: this.props.value,
  }
  validatorTypes = strategy.createSchema(
    {
      link: LINK_VALIDATOR,
    },
    {
      [LINK_VALIDATOR]: 'The url format is invalid.',
    },
    validator => {
      validator.constructor.register(LINK_VALIDATOR, validateLink)
    },
  )
  getValidatorData = () => ({
    link: this.state.value.url,
  })
  _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = cloneDeep(this.state.value)
    set(
      value,
      e.target.name,
      e.target.name === 'url' ? fixLink(e.target.value) : e.target.value,
    )
    this.setState({
      value,
    })
  }
  _handleSubmit = () =>
    this.props.validate(error => {
      if (!error) this.props.onSubmit(this.state.value)
    })

  render() {
    return (
      <div className="rich-text-toolbar__settings">
        <h3 className="rich-text-toolbar__settings__header">Link settings</h3>
        <LinkPropsView
          value={this.state.value}
          className="rich-text-toolbar__settings__list"
          onChange={this._onChange}
          validationErrors={{
            link: this.props.getValidationMessages('link').toString(),
          }}
        />
        <ButtonContainer>
          <Button
            appearance="primary"
            caption="Apply"
            onClick={this._handleSubmit}
          />
          <Button caption="Cancel" onClick={this.props.onCancel} />
        </ButtonContainer>
      </div>
    )
  }
}

export default validation(strategy)(LinkSettings) as any
